import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

export interface RenewalPortfolioCardThemeProps {
  productsLength: number;
  isSelectedAsRenew: boolean;
  isCancelled: boolean;
}

const styles: ComponentStylesProps<RenewalPortfolioCardThemeProps> = {
  multiProductCard: {
    display: 'flex',
    flexDirection: 'column',
  },
  productsList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 25rem)',
    gap: '2rem',
    justifyContent: 'center',
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    marginBottom: '0.5rem',
  },
  multiProductWrapper: {
    display: 'grid',
    gap: '1.5rem',
    backgroundColor: colors.neutral.white,
    width: '25rem',
    borderRadius: '1.5rem',
    padding: '2rem',
    boxSizing: 'border-box',
    border: `0.1rem solid ${colors.neutral[300]}`,
    gridAutoRows: 'auto 1fr',
  },
  productTitle: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    color: colors.neutral[900],
    margin: 0,
    letterSpacing: '0.02em',
    fontWeight: '400',
  },
  singleProductPortfolioTitle: {
    alignSelf: 'self-start',
    marginTop: '1.5rem',
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${colors.neutral[200]}`,
  },
  multiProductPortfolioTitle: {
    paddingLeft: `1rem`,
    marginBottom: 0,
    maxWidth: '90%',
  },
  multiProductHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '2rem',
    marginBottom: '2rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
  },
  ratesItem: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '1rem',
    alignItems: 'center',
    fontSize: '1.4rem',
    lineHeight: '2rem',
    letterSpacing: '0.02em',
    '& span:first-child': {
      overflowWrap: 'break-word',
      maxWidth: '12rem',
    },
    '& span:last-child': {
      fontWeight: 700,
      color: colors.green[600],
    },
    '&:not(:last-child)': {
      marginBottom: '0.8rem',
    },
  },
  downloadButton: ({ productsLength }) => ({
    textTransform: 'uppercase',
    padding: 0,
    marginRight: productsLength > 1 && '1rem',
  }),
  renewalProductHeader: ({ productsLength }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem',
    marginTop: 0,
    marginLeft: productsLength === 1 ? '0rem' : '0.5rem',
  }),
  renewalProductCard: ({ isSelectedAsRenew, isCancelled, productsLength }) => ({
    position: 'relative',
    border: `0.1rem solid ${
      // eslint-disable-next-line no-nested-ternary
      isSelectedAsRenew ? colors.blue[600] : isCancelled ? colors.red[600] : colors.neutral[200]
    }`,
    borderRadius: '1.5rem',
    padding: productsLength === 1 ? '2rem' : '2rem 1rem',
    boxSizing: 'border-box',
    // eslint-disable-next-line no-nested-ternary
    width: productsLength === 1 ? '56rem' : productsLength <= 3 ? `${26.5 * productsLength + 3}rem` : '100%',
    display: 'grid',
    gap: '1.5rem',
    alignItems: 'end',
    gridAutoRows: productsLength === 1 ? 'auto auto 1fr 3rem' : 'auto auto auto',
  }),
  renewalsButtons: ({ productsLength }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginLeft: productsLength === 1 ? '0rem' : '0.5rem',
    maxWidth: '22rem',
    '& button': {
      textTransform: 'uppercase',
      paddingLeft: 0,
    },
  }),
  renewAsIsButton: {
    '& span, & svg': {
      height: '1.8rem',
    },
  },
  renewalCardContent: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '6rem',
    paddingBottom: '1.5rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
  },
  renewalRatesList: {
    maxWidth: '22rem',
    padding: '0',
    margin: 0,
  },
  ratesWrapper: {
    position: 'relative',
    '&::after': {
      content: "''",
      position: 'absolute',
      width: '0.1rem',
      height: '100%',
      top: 0,
      bottom: 0,
      right: '-3.6rem',
      backgroundColor: colors.neutral[200],
    },
  },
  multiProductRatesWrapper: {
    paddingTop: '1.5rem',
    borderTop: `0.1rem solid ${colors.neutral[300]}`,
  },
  renewalTag: ({ isSelectedAsRenew, isCancelled }) => ({
    position: 'absolute',
    margin: 0,
    width: '100%',
    top: '-0.1rem',
    left: 0,
    padding: '0.8rem 0',
    color: colors.neutral.white,
    fontSize: '1.4rem',
    textAlign: 'center',
    lineHeight: '2rem',
    borderRadius: '1.5rem 1.5rem 0 0',
    // eslint-disable-next-line no-nested-ternary
    backgroundColor: isSelectedAsRenew ? colors.blue[600] : isCancelled ? colors.red[600] : colors.neutral[300],
  }),
  ratesTitle: {
    font: { size: '1.4rem', lineHeight: '2rem' },
    fontWeight: 700,
    letterSpacing: '0.02em',
    color: colors.neutral[700],
    textTransform: 'uppercase',
    margin: 0,
    marginBottom: '1.5rem',
  },
  ratesMessage: {
    fontSize: '1.4rem',
    color: colors.neutral[900],
    display: 'flex',
    alignItems: 'center',
    '& span': {
      marginLeft: '1rem',
    },
  },
  addBenefitButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
